(() => {
  const root = document.querySelector('[data-yaupon-article]');
  if (!root) return;

  const body = root.querySelector('.yt-article-body');
  const desktopList = root.querySelector('#ytTocDesktop');
  const mobileList = root.querySelector('#ytTocMobile');
  const tocLevels = root.dataset.tocLevels || 'h2,h3';
  const headings = body
    ? [...body.querySelectorAll(tocLevels)].filter((heading) => !heading.closest('[data-toc-exclude], .aonsk-article-toc, .aonsk-related-series, .aonsk-chapter-nav'))
    : [];

  const slugify = (text) => text.toLowerCase().trim()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');

  const usedIds = new Set();
  headings.forEach((heading) => {
    if (heading.id) usedIds.add(heading.id);
  });

  if (headings.length) {
    headings.forEach((heading, index) => {
      if (!heading.id) {
        const base = slugify(heading.textContent) || `article-section-${index + 1}`;
        let candidate = base;
        let count = 2;
        while (usedIds.has(candidate)) candidate = `${base}-${count++}`;
        heading.id = candidate;
        usedIds.add(candidate);
      }

      [desktopList, mobileList].forEach((list) => {
        if (!list) return;
        const item = document.createElement('li');
        if (heading.tagName === 'H3') item.className = 'is-subheading';
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        item.appendChild(link);
        list.appendChild(item);
      });
    });

    body.querySelectorAll('.aonsk-article-toc, .aonsk-chapter-nav, .aonsk-related-series').forEach((oldNavigation) => {
      oldNavigation.hidden = true;
    });

    if ('IntersectionObserver' in window && desktopList) {
      const links = [...desktopList.querySelectorAll('a')];
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          links.forEach((link) => link.classList.toggle('is-active', link.getAttribute('href') === `#${entry.target.id}`));
        });
      }, { rootMargin: '-18% 0px -70% 0px' });
      headings.forEach((heading) => observer.observe(heading));
    }
  } else {
    root.querySelectorAll('.yt-sidebar-card--toc, .yt-mobile-toc').forEach((element) => { element.hidden = true; });
  }

  const progress = root.querySelector('.yt-reading-progress span');
  const updateProgress = () => {
    if (!progress || !body) return;
    const start = body.getBoundingClientRect().top + window.scrollY;
    const distance = body.offsetHeight - window.innerHeight;
    const amount = distance > 0 ? Math.min(1, Math.max(0, (window.scrollY - start + 120) / distance)) : 0;
    progress.style.transform = `scaleX(${amount})`;
  };
  updateProgress();
  window.addEventListener('scroll', updateProgress, { passive: true });
  window.addEventListener('resize', updateProgress);
})();
